var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7182 4.39071C20.0109 4.08355 20.3582 3.8399 20.7405 3.67367C21.1229 3.50743 21.5326 3.42188 21.9464 3.42188C22.3602 3.42187 22.77 3.50743 23.1523 3.67367C23.5346 3.8399 23.882 4.08355 24.1746 4.39071C24.4672 4.69787 24.6993 5.06252 24.8577 5.46385C25.0161 5.86517 25.0976 6.29531 25.0976 6.7297C25.0976 7.16409 25.0161 7.59422 24.8577 7.99555C24.6993 8.39687 24.4672 8.76152 24.1746 9.06868L9.13435 24.8568L3.00684 26.6111L4.67798 20.1788L19.7182 4.39071Z",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPencil;